export default __webpack_public_path__ + "static/media/otherExistingEmail.e8aada4f.svg";